<!--
 * @Author: 四川华西绿舍建材有限公司
 * @Date: 2024-03-05 09:24:51
 * @LastEditors: hexy 913752270@qq.com
 * @LastEditTime: 2026-06-16 14:49:24
 * @Description: 配合比库-复用配合比
 * @FilePath: \ICPSxin\src\views\platform\ICPS\basicConfig\components\mixRatio.vue
-->
<template>
  <div>
    <el-dialog v-loading="saveLoad" :visible.sync="mixRatioDialog" width="1300px" :close-on-click-modal="false"
      :append-to-body="true" :before-close="resetRawFromDate">
      <span slot="title" class="dialog-title">{{ mixRatioTitle }}</span>
      <div class="dialoginfo">
        <div style="margin-bottom: 10px">
          <span>配合比名称:</span>
          <span v-if="lineList[currentIndex].mixName" style="color: red" @click="chooseMix()">{{
            lineList[currentIndex].mixName }}</span>
          <span v-else style="color: red" @click="chooseMix()">请选择</span>
          <span style="margin-left:24px">工程名称:</span><span>{{ mixData.engineeringName }}</span>
          <span style="margin-left:24px">浇筑部位:</span><span>{{ mixData.structuralParts }}</span>
          <span style="margin-left:24px">产品名称:</span><span>{{ mixData.productName }}</span>
          <span style="margin-left:24px">浇筑方式:</span><span>{{ mixData.pouringMethodSplit }}</span>
          <span style="margin-left:24px">订单号:</span><span>{{ mixData.code }}</span>
        </div>
        <div class="tabtop" :style="{ width: lineList.length * 190 + 'px', marginTop: '30px', marginLeft: '0px' }">
          <div v-for="(item, index) in lineList" :key="index">
            <div :class="{
              active: currentIndex == item.index,
              activeEnable: currentIndex == item.index && lineList[currentIndex].enable == 0,
              text: currentIndex != item.index && item.enable == 1 && !(currentIndex == item.index && lineList[currentIndex].enable == 1),
              textEnable: currentIndex != item.index && item.enable == 0,
            }" @click="choose(item)">
              {{ item.name }}
            </div>
          </div>
        </div>

        <!-- <div class="tabtop" :style="{ width: lineList.length * 190 + 'px', marginTop: '30px', marginLeft: '0px' }">
          <div v-for="(item, index) in lineList" :key="index"  >
            <div :class="currentIndex == item.index ? 'active' : 'text'" :style="{ background: lineList[currentIndex].enable== 1 ? item.color : 'red' }" @click="choose(item)">{{ item.name }}</div>
          </div>
        </div> -->
        <div style="position: relative; margin-top: 30px">
          <div style="margin-bottom: 10px; height: 30px">
            <el-switch v-model="lineList[currentIndex].enable" class="switch" :active-value="1" :inactive-value="0"
              active-color="#13ce66" inactive-color="#ff4949" active-text="启用" inactive-text="禁用"
              style="padding-left: 10px" width:60></el-switch>
            <!--
               @change="handleSwitchChange(lineList[currentIndex].enable)" -->
            <span style="margin-left: 45px">搅拌时间:</span>
            <el-input v-model="lineList[currentIndex].mixTime" type="number" :min="1" style="width: 150px"
              :disabled="lineList[currentIndex].enable == 0" placeholder="请输入">
              <template slot="append"> s</template>
            </el-input>
            <span v-if="judgeMixCheckTime">
            <span style="margin-left: 45px">自动取样时间:</span>
            <el-input v-model="lineList[currentIndex].sampleTime" type="number" :min="1" style="width: 150px"
              :disabled="lineList[currentIndex].enable == 0" placeholder="请输入">
              <template slot="append"> s</template>
            </el-input>
            <span style="margin-left: 45px">延迟取样时间:</span>
            <el-input v-model="lineList[currentIndex].putOffSampleTime" type="number" :min="1" style="width: 150px"
              :disabled="lineList[currentIndex].enable == 0" placeholder="请输入">
              <template slot="append"> s</template>
            </el-input>
            </span>
            <span style="margin-left: 45px">取样:</span>
            <el-switch v-model="lineList[currentIndex].takeSampleControl" class="switch" :active-value="1" :inactive-value="0"
              active-color="#13ce66" inactive-color="#ff4949"
              style="padding-left: 10px" width:60></el-switch>
           
          </div>
          <div style="position: absolute; right: 0; top: 0">
            <el-button class="bottom_all" :disabled="lineList[currentIndex].enable == 0" @click="addItem">添 加</el-button>
          </div>
          <!-- stripe 
            :style="{ backgroundColor: lineList[currentIndex].enable == 0 ? 'red' : '' }"
          -->
          <div style="width: 100%; background-color: red; margin-top: 10px">
            <!-- <div :class="tableClassEnable"> :key="`table${currentIndex}`" -->
            <el-table :key="tableKey" :ref="`multipleTable${currentIndex}`" :header-cell-style="{ background: '#f3f6f9' }"
              :class="`draggable-table${currentIndex}`" :cell-style="cellStyle" border
              :data="lineList[currentIndex].mixInfoList" tooltip-effect="dark" highlight-current-row row-key="idKey"
              :row-class-name="rowClassName">
              <template v-for="(item, index2) in tableList">
                <el-table-column v-if="(item.label == '对外仓' || item.label == '对外量(kg/m³)') ? isMixOut : item.status"
                  :key="index2" :label="item.label" align="center" :min-width="item.width" :fixed="item.fixed"
                  :prop="item.prop" :class-name="sortClass" :sortable="item.sortable">
                  <template slot-scope="scope">
                    <div v-if="item.label == '理论用量(kg/m³)'">
                      <el-input v-if="scope.row.name != '容重' && scope.row.name != '胶凝材料'" v-model="scope.row.theoreValue"
                        style="width: 120px" disabled
                        onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"
                        @input="scope.row.theoreValue = $regExp.checkNum(scope.row.theoreValue)"
                        @blur="scope.row.theoreValue = $regExp.blurCheckNum(scope.row.theoreValue)" />
                      <el-input v-else v-model="scope.row.theoreValue" style="width: 120px"
                        oninput="value=value.replace(/[^0-9.]/g,'')" disabled />
                    </div>
                    <div v-else-if="item.label == '实际用量(kg/m³)'">
                      <el-input v-if="scope.row.name != '容重' && scope.row.name != '胶凝材料'"
                        v-model="scope.row.theoreValueTrue" style="width: 120px"
                        :disabled="lineList[currentIndex].enable == 0"
                        onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"
                        oninput="value=value.replace(/[^0-9.]/g,'')" @focus="disableDrag"
                        @input="scope.row.theoreValueTrue = $regExp.checkNum(scope.row.theoreValueTrue)"
                        @blur="(scope.row.theoreValueTrue = $regExp.blurCheckNum(scope.row.theoreValueTrue)), setbleDrag()" />
                      <el-input v-else v-model="scope.row.theoreValueTrue" style="width: 120px" disabled
                        oninput="value=value.replace(/[^0-9.]/g,'')" />
                    </div>
                    <span v-else-if="item.label == '原物料' && scope.row.name != '容重' && scope.row.name != '胶凝材料'">
                      <span v-if="scope.row.name" @click="chooseRaw(false, scope.$index)">{{ scope.row.name }}</span>
                      <span v-else style="color: red" @click="chooseRaw(true, '')">请选择</span>
                    </span>
                    <div v-else-if="item.label == '使用仓' && scope.row.name != '容重' && scope.row.name != '胶凝材料'">
                      <el-select :key="lineList[currentIndex].lineId + scope.$index" v-model="scope.row.rawFormId"
                        style="width: 120px" :disabled="lineList[currentIndex].enable == 0" placeholder="请选择"
                        @change="selectWarehouse(scope.$index, scope.row.rawList)">
                        <el-option v-for="item in scope.row.rawList" :key="item.warehouseId" :label="item.warehouseName"
                          :value="item.warehouseId"> </el-option>
                      </el-select>
                    </div>
                    <div v-else-if="item.label == '偏差(kg)'">
                      <el-input v-if="scope.row.name != '容重' && scope.row.name != '胶凝材料'" v-model="scope.row.deviation"
                        style="width: 120px" oninput="value=value.replace(/[^0-9.]/g,'')" disabled />
                      <el-input v-else v-model="scope.row.deviation" style="width: 120px" disabled
                        oninput="value=value.replace(/[^0-9.]/g,'')" />
                    </div>
                    <div v-else-if="item.label == '对外量(kg/m³)'">
                      <el-input v-if="scope.row.name != '容重' && scope.row.name != '胶凝材料'"
                        v-model="scope.row.theoreValueTrueOut" style="width: 120px"
                        :disabled="lineList[currentIndex].enable == 0"
                        onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"
                        oninput="value=value.replace(/[^0-9.]/g,'')" @focus="disableDrag"
                        @input="scope.row.theoreValueTrueOut = $regExp.checkNum(scope.row.theoreValueTrueOut);"
                        @blur="(scope.row.theoreValueTrueOut = $regExp.blurCheckNum(scope.row.theoreValueTrueOut)), setbleDrag()" />
                      <el-input v-else v-model="scope.row.theoreValueTrueOut" style="width: 120px" disabled
                        oninput="value=value.replace(/[^0-9.]/g,'')" />
                    </div>
                    <div v-else-if="item.label == '对外仓' && scope.row.name != '容重' && scope.row.name != '胶凝材料'">
                      <el-select :key="lineList[currentIndex].lineId + scope.$index" v-model="scope.row.rawFormCodeOut"
                        style="width: 120px" :disabled="lineList[currentIndex].enable == 0" placeholder="请选择">
                        <el-option v-for="item in warehouseBindList" :key="item.useCode" :label="item.useAliasName"
                          :value="item.useCode"> </el-option>
                      </el-select>
                    </div>
                    <div v-else-if="item.label == '操作' && scope.row.name != '容重' && scope.row.name != '胶凝材料'">
                      <el-link :underline="false" type="danger" style="margin: 5px 0"
                        :disabled="lineList[currentIndex].enable == 0" @click="deleteItem(scope.$index)">删除</el-link>
                    </div>
                    <span v-else>{{ scope.row[item.prop] || "-" }}</span>
                  </template>
                </el-table-column>
              </template>
            </el-table>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="resetRawFromDate">取 消</el-button>
        <el-button class="bottom_all" style="margin-left: 24px" @click="saveRawFromDate(1)">保 存</el-button>
        <el-button class="bottom_four" style="margin-left: 24px" :disabled="isSaveNow"
          @click="saveRawFromDate(2)">保存并传送拌台</el-button>
      </span>
    </el-dialog>
    <!-- 保存弹窗 -->
    <el-dialog :visible.sync="saveMixRatioDialog" width="560px" top="35vh" :close-on-click-modal="false" :append-to-body="true">
      <span slot="title" class="dialog-title">提示:请确认是否传送拌台!</span>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="saveMixRatioDebounce(false)">取 消</el-button>
        <el-button class="bottom_all" style="margin-left: 24px" @click="saveMixRatioDebounce(true)">确认</el-button>
      </span>
    </el-dialog>
    <!-- 选择原物料 -->
    <rawChoose ref="rawChoose" :isChooseRawDialog.sync="isChooseRaw" :isUpdate.sync="isUpdateType"
      :isRawIndex.sync="rawIndex" :stationId.sync="rowData.stationId" @selectRaw="selectRaw" />
    <!-- 复用配合比 -->
    <mixRawAgain ref="mixRawAgain" :lookRawDialog.sync="lookRaw" :isShowType.sync="showType" :statName.sync="staName"
      :statId.sync="staId" :proName.sync="prName" :isMixOut.sync="isMixOut" :warehouseBindList.sync="warehouseBindList"
      @selectRawDetail="selectRawDetail" />
  </div>
</template>

<script>
import rawChoose from "./rawChoose.vue";
import mixRawAgain from "./mixRawAgain.vue";
import { queryOneByPlan, getRaw, saveMixRatio,judgeMixCheckTimeControl } from "@/api/basicConfig/mixIssue.js";
import { queryProcesses } from "@/api/basicConfig/proflow.js";
import {
  queryWarehouseUse,
} from "@/api/basicConfig/site.js";
import { getPLByStationId } from "@/api/basicConfig/site.js";
import { _debounce } from "@/utils/utils.js";
// import { compareArrays } from "@/utils/utils";

export default {
  components: {
    rawChoose,
    mixRawAgain,
  },
  data() {
    return {
      /*表格增删改查及下载接口*/
      options: [],
      /*表格数据*/
      mixRatioTitle: "开具配合比",
      isSaveNow: false,
      //  选择原物料
      isChooseRaw: false,
      isUpdateType: false,
      rawIndex: 0,
      lookRaw: false,
      showType: false,
      prName: "",
      staName: "",
      staId: "",
      value: 0,
      tableParam: {
        page: 1,
        pageSize: 10,
        productName: "",
        name: "",
        enable: 1,
      },
      fromData: {},
      total: 0,
      tableDataDetail: [],
      rawList: [], //原料库下拉框--根据站点生产线来判断
      selectRatio: [],
      tableList: [
        { label: "原物料", width: "220", prop: "name", status: true, sortable: false },
        { label: "理论用量(kg/m³)", width: "100", prop: "theoreValue", status: true, sortable: false },
        { label: "实际用量(kg/m³)", width: "100", prop: "theoreValueTrue", status: true, sortable: false },
        { label: "偏差(kg)", width: "100", prop: "deviation", status: true, sortable: false },
        { label: "使用仓", width: "120", prop: "rawFormId", status: true, sortable: false },
        { label: "对外量(kg/m³)", width: "100", prop: "theoreValueTrueOut", status: true, sortable: false },
        { label: "对外仓", width: "120", prop: "rawFormCodeOut", status: true, sortable: false },
        { label: "操作", width: "auto", prop: "", status: true, sortable: false },
      ],
      currentIndex: 0,
      rowData: {},
      mixInfoList: [],
      lineList: [
        {
          mixName: "",
          mixTime: 0,
          lineId: "",
          lineName: "",
          enable: 0,
          takeSampleControl:1,
          mixInfoList: [],
        },
      ],
      rules: {
        theoreValue: [{ required: true, message: "理论用量不能为空", trigger: "blur" }],
        theoreValueTrue: [{ required: true, message: "实际理论用量不能为空", trigger: "blur" }],
        rawFormId: [{ required: true, message: "原料库不能为空", trigger: "blur" }],
      },
      saveLoad: false,
      sortClass: "allowDrag",
      tableKey: false,
      warehouseBindList: [],
      saveMixRatioDialog: false,
      saveMixRatioDataArr: [],
      judgeMixCheckTime:false,
      // 用于获取到的默认取样时间
      defaultSampleTime: "",
      defaultPutOffSampleTime: "",
    };
  },
  props: {
    mixRatioDialog: {
      type: Boolean,
      default: false,
    },
    isSaveType: {
      type: Boolean,
      default: false,
    },
    isMixOut: {
      type: Boolean,
      default: false,
    },
    mixData: {
      type: Object,
      default: () => { },
    },
  },
  watch: {
    mixData(val) {
      this.rowData = val;
      this.prName = this.rowData.productName;
      this.staName = this.rowData.stationName;
      this.staId = this.rowData.stationId;
      judgeMixCheckTimeControl({servicePointId:this.rowData.stationId}).then(res => {
        this.judgeMixCheckTime = res.data
      })
    },
    isSaveType(val) {
      this.isSaveNow = val;
    },
    lineList: {
      handler(newValue) {
        let theoreValueJs = 0;
        let theoreValueTrueJs = 0;
        let theoreValueTrueOutJs = 0;
        console.log("newValue")
        console.log(newValue)
        newValue[this.currentIndex].mixInfoList.forEach((item, index) => {
          item.idKey = item.name + index + item.rawFormId;
          if (item.name.indexOf("水泥") !== -1 || item.name.indexOf("煤灰") !== -1 || item.name.indexOf("矿粉") !== -1 || item.name.indexOf("复合") !== -1) {
            theoreValueJs = theoreValueJs + item.theoreValue * 1;
            theoreValueTrueJs = theoreValueTrueJs + item.theoreValueTrue * 1;
            theoreValueTrueOutJs = theoreValueTrueOutJs + item.theoreValueTrueOut * 1;
          }
          if (item.name !== '容重' && item.name !== '胶凝材料') {
            this.handleInput(item.theoreValue, '理论用量')
            this.handleInput(item.theoreValueTrue, '实际用量')
          }
        });
        let obj = {
          name: "胶凝材料",
          theoreValue: theoreValueJs,
          theoreValueTrue: theoreValueTrueJs,
          theoreValueTrueOut: theoreValueTrueOutJs,
          deviation: "",
        };
        let index = this.lineList[this.currentIndex].mixInfoList.findIndex(item2 => item2.name == "胶凝材料");
        if (index == -1) {
          this.lineList[this.currentIndex].mixInfoList.push(obj);
        } else {
          this.$set(this.lineList[this.currentIndex].mixInfoList[index], "theoreValue", theoreValueJs);
          this.$set(this.lineList[this.currentIndex].mixInfoList[index], "theoreValueTrue", theoreValueTrueJs);
          this.$set(this.lineList[this.currentIndex].mixInfoList[index], "theoreValueTrueOut", theoreValueTrueOutJs);
        }
      },
      deep: true,
    },
  },
  async created() {
    /*存储拷贝的原初始化fromDate数据*/
    // this.tableParam = { ...this.tableParam, name: "", productName: "", stationName: "" };
    // await this.queryOneByPlan();
  },
  async mounted() {
    /*存储拷贝的原初始化fromDate数据*/
    this.selectRatio = [];
  },
  methods: {
    rowClassName(data) {
      console.log("111");
      if (data.rowIndex >= this.lineList[this.currentIndex].mixInfoList.length - 2) {
        return "rowClassFilter";
      }
    },
    disableDrag() {
      this.sortClass = "";
    },
    setbleDrag() {
      this.sortClass = "allowDrag";
    },
    rowDrop() {
      // 此时找到的元素是要拖拽元素的父容器
      const tbody = document.querySelector(`.draggable-table${this.currentIndex} .el-table__body-wrapper tbody`);
      console.log(tbody);
      this.$Sortable.create(tbody, {
        handle: ".allowDrag", // 格式为简单css选择器的字符串，使列表单元中符合选择器的元素成为拖动的手柄，只有按住拖动手柄才能使列表单元进行拖动
        draggable: ".el-table__row", // 允许拖拽的项目类名
        animation: 150, // ms, number 单位：ms，定义排序动画的时间
        filter: ".rowClassFilter", //过滤不可拖拽的元素
        onEnd: ({ newIndex, oldIndex }) => {
          const currRow = this.lineList[this.currentIndex].mixInfoList.splice(oldIndex, 1)[0];
          this.lineList[this.currentIndex].mixInfoList.splice(newIndex, 0, currRow);
        },
        onMove(e) {
          return e.related.className.indexOf("rowClassFilter") === -1;
        },
      });
    },
    choose(item) {
      this.currentIndex = item.index;
      this.lineList[this.currentIndex].lineName = item.name;
      this.lineList[this.currentIndex].lineId = item.id;
      this.tableKey = !this.tableKey;
      this.getRaw();
    },
    async getRaw() {
      let that = this;
      let array = JSON.parse(JSON.stringify(that.lineList[that.currentIndex].mixInfoList));
      array.forEach(item => {
        if (item.id != "") {
          getRaw({ lineId: that.lineList[that.currentIndex].lineId, rawId: item.id, page: 1, pageSize: 1000 }).then(res => {
            if (res.code === 1001) {
              let rawFormList = [];
              rawFormList = res.data.map(item => ({
                warehouseId: item.warehouseId,
                warehouseName: item.warehouseName,
                warehouseCode: item.originPlace,
              }));
              this.$set(item, "rawList", rawFormList);
              if (rawFormList?.length == 1) {
                this.$set(item, "rawList", rawFormList);
                this.$set(item, "rawFormId", rawFormList[0].warehouseId);
                this.$set(item, "rawForm", rawFormList[0].warehouseName);
                this.$set(item, "rawFormCode", rawFormList[0].warehouseCode);
              }
            }
          });
        }
      });
      that.lineList[that.currentIndex].mixInfoList = array;
      this.mixRatioDialog = true;
      // this.$refs[`multipleTable${this.currentIndex}`].doLayout();
      this.$nextTick(() => {
        this.rowDrop();
      });

      // 3000毫秒 = 3秒
      this.$forceUpdate();
    },
    getLineList() {
      getPLByStationId({ stationId: this.rowData.stationId }).then(res => {
        if (res.code === 1001) {
          if (res.data?.length > 0) {
            this.lineList = res.data.map((item, index) => ({
              index: index,
              id: item.id,
              name: item.name,
              mixName: "",
              mixTime: 0,
              lineId: item.id,
              mixId:item.mixId,
              lineName: item.name,
              lineCode: item.code,
              enable: 1,
              takeSampleControl:1,
              theoreValueTrue: "",
              // sampleTime:5,
              // putOffSampleTime:5,
              sampleTime: this.defaultSampleTime,
              putOffSampleTime: this.defaultPutOffSampleTime,
              theoreValue: "",
              deviation: "",
              mixInfoList: [{ id: "", name: "容重", theoreValue: "", deviation: "", theoreValueTrue: "", theoreValueTrueOut: "", rawFormId: "", rawFormCodeOut: "", rawList: [] }],
            }));
            this.currentIndex = this.lineList[0].index;
            this.queryOneByPlan();
          } else {
            this.$emit("update:mixRatioDialog", false);
            this.$message.warning("暂无生产线，请先配置生产线");
          }
          queryWarehouseUse({ stationId: this.rowData.stationId }).then(res2 => {
            if (res2.code == 1001) {
              this.warehouseBindList = res2.data;
            }
          })

        }
      });
    },
    queryOneByPlan() {
      let that = this;
      queryOneByPlan({ planId: this.rowData.id }).then(res => {
        if (res.code === 1001) {
          if (res.data?.length > 0) {
            that.lineList.forEach(item1 => {
              res.data.forEach(item2 => {
                if (item1.id == item2.lineId) {
                  item1.mixInfoList = JSON.parse(item2.mixInfo);
                  let obj = { id: "", name: "容重", theoreValue: item2.theoreValue, deviation: item2.deviation, theoreValueTrue: item2.theoreValueTrue, rawFormId: "", rawList: [] };
                  let index = item1.mixInfoList.findIndex(item => item.name == "容重");
                  if (index == -1) {
                    item1.mixInfoList.push(obj);
                  }
                  item1.planId = that.rowData.id;
                  item1.mixName = item2.mixName;
                  item1.mixTime = item2.mixTime;
                  // this.$set(item1,'sampleTime',item2.sampleTime ? item2.sampleTime : 5)
                  // this.$set(item1,'putOffSampleTime',item2.putOffSampleTime ? item2.putOffSampleTime : 5)
                  this.$set(item1,'sampleTime',item2.sampleTime ? item2.sampleTime : this.defaultSampleTime)
                  this.$set(item1,'putOffSampleTime',item2.putOffSampleTime ? item2.putOffSampleTime : this.defaultPutOffSampleTime)
                  item1.lineId = item2.lineId;
                  item1.lineName = item2.lineName;
                  item1.stationId = this.rowData.stationId;
                  item1.stationName = this.rowData.stationName;
                  item1.enable = item2.enable;
                  item1.takeSampleControl = item2.takeSampleControl;
                  item1.mixId = item2.mixId;
                }
              });
            });
            this.getRaw();
            // this.$forceUpdate();
          }
        }
      });
    },
    //主页面添加事件
    async addClick(data) {
      this.rowData = data;
      // 调用接口获取工艺流程中的默认取样时间设置
      this.defaultSampleTime = "";
      this.defaultPutOffSampleTime = "";
      let res = await queryProcesses({ stationId: this.rowData.stationId });
      if (res.code === 1001 && res.data && res.data.sampleTime) {
        let st = JSON.parse(res.data.sampleTime);
        this.defaultSampleTime = st.sampleTime ?? "";
        this.defaultPutOffSampleTime = st.putOffSampleTime ?? "";
      }
      this.getLineList();
    },
    handleInput(val, name) {
      val = Number(val)
      if (val || val == 0) {
        this.getSummaries();
      } else {
        this.$message({
          type: "warning",
          message: `${name}不可以为空`,
        });
      }
    },
    getSummaries() {
      // 修改配合比的时候理论用量容重不参与更改
      var array = this.lineList[this.currentIndex].mixInfoList.filter(item => item.name !== "容重" && item.name !== "胶凝材料");
      let array1 = 0;
      let array2 = 0;
      let array3 = 0;
      let sum = 0;
      let sum2 = 0;
      let sum3 = 0;
      if (this.isSaveNow) {
        array1 = array.map(item => parseFloat(item.theoreValue)).filter(value => !isNaN(value)); // 过滤空值
        sum = array1.length > 0 ? array1.reduce((accumulator, current) => accumulator + current) : 0;
        array2 = array.map(item => parseFloat(item.theoreValueTrue));
        sum2 = array2.reduce((accumulator, current) => accumulator + current, 0);
        array3 = array.map(item => parseFloat(item.theoreValueTrueOut));
        sum3 = array3.reduce((accumulator, current) => accumulator + current, 0);
        this.lineList[this.currentIndex].mixInfoList.forEach(item => {
          if (item.name === "容重") {
            item.theoreValue = sum; //
            item.theoreValueTrue = sum2; //
            item.theoreValueTrueOut = sum3; //
          }
        });
      } else {
        array2 = array.map(item => parseFloat(item.theoreValueTrue));
        sum2 = array2.reduce((accumulator, current) => accumulator + current, 0);
        array3 = array.map(item => parseFloat(item.theoreValueTrueOut));
        sum3 = array3.reduce((accumulator, current) => accumulator + current, 0);
        this.lineList[this.currentIndex].mixInfoList.forEach(item => {
          if (item.name === "容重") {
            // item.theoreValue = sum; //
            item.theoreValueTrue = sum2;
            item.theoreValueTrueOut = sum3;
          }
        });
      }
    },
    chooseRaw(type, index) {
      this.isChooseRaw = true;
      this.isUpdateType = type;
      this.rawIndex = index;
      this.prName = this.rowData.productName;
      this.staName = this.rowData.stationName;
      this.staId = this.rowData.stationId;
      this.$refs.rawChoose.addClick();
    },
    chooseMix() {
      console.log(this.rowData.stationId);
      this.$refs.mixRawAgain.addClick(this.rowData.stationId);
      this.lookRaw = true;
      this.showType = true;
    },
    //改变表格某一列或者某一个单元格文本颜色
    cellStyle({ row, column }) {
      // 定义样式变量
      let cellStyle;
      // 根据每一行的status属性的值进行判断
      // 如果是正常就展示以绿色字体展示，如果是禁用就以红色颜色展示
      if (this.lineList[this.currentIndex].enable == 0) {
        cellStyle = "background:#d0d0d0;color: #ffffff;border-right: none;";
        return cellStyle;
      } else {
        if (row.deviation) {
          switch (Math.abs(row.theoreValueTrue - row.theoreValue) > Number(row.deviation)) {
            // 0代表正常
            case true:
              // 设置文本颜色 红色 可以直接写颜色编码，也可以直接写颜色的单词
              cellStyle = "background:red;border-right: none;";
              break;
            // 0代表金禁用
            case false:
              // 设置文本颜色 绿色
              // , borderRight: none
              cellStyle = " border-right: none;";
              break;
            // 如果有其他状态，就默认显示，不给文本颜色
            default:
              cellStyle = "";
          }
          //return cellStyle  // 返回最终处理过的样式 这样写就是让全部行被style修饰
          // 返回最终处理过的样式 只让账号状态这个属性的属性被style修饰
          if (column.label == "实际用量(kg/m³)") {
            return cellStyle;
          }
        } else {
          cellStyle = " border-right: none;";
          return cellStyle;
        }
      }
    },
    addItem() {
      this.chooseRaw(true, "");
    },
    deleteItem(index) {
      var array = JSON.parse(JSON.stringify(this.lineList[this.currentIndex].mixInfoList));
      array.splice(index, 1);
      this.lineList[this.currentIndex].mixInfoList = array;
      this.getSummaries();
    },
    selectWarehouse(index, warehouseList) {
      this.$nextTick(() => {
        let warehouseItem = warehouseList.find(item => item.warehouseId == this.lineList[this.currentIndex].mixInfoList[index].rawFormId);
        this.$set(this.lineList[this.currentIndex].mixInfoList[index], "rawForm", warehouseItem.warehouseName);
        this.$set(this.lineList[this.currentIndex].mixInfoList[index], "rawFormCode", warehouseItem.warehouseCode);
      });
    },
    /*选择原物料回调 */
    selectRaw(data, type, index) {
      // if (compareArrays(data, this.lineList[this.currentIndex].mixInfoList, "id")) {
      //   this.$message({ type: "warning", message: "存在重复添加的物品信息，请重新选择!" });
      //   return;
      // } else {
      if (type) {
        // 新增
        this.lineList[this.currentIndex].mixInfoList.unshift(data[0]);
      } else {
        // 修改
        // this.lineList[this.currentIndex].mixInfoList[index] = data[0];
        this.lineList[this.currentIndex].mixInfoList[index].id = data[0].id
        this.lineList[this.currentIndex].mixInfoList[index].idKey = data[0].idKey
        this.lineList[this.currentIndex].mixInfoList[index].name = data[0].name
        this.lineList[this.currentIndex].mixInfoList[index].rawList = data[0].rawList
        this.lineList[this.currentIndex].mixInfoList[index].rawFormId = data[0].rawFormId
        this.lineList[this.currentIndex].mixInfoList[index].rawForm = data[0].rawForm
        this.lineList[this.currentIndex].mixInfoList[index].rawFormCode = data[0].rawFormCode
      }
      this.getRaw();
      // }
      this.$forceUpdate();
    },
    selectRawDetail(data, name, mixTime, mixId) {
      let that = this;
      //  var array = JSON.parse(JSON.stringify(that.lineList));
      that.lineList.forEach((item, index) => {
        //  that.lineList.forEach(item => {
        item.mixInfoList = data;
        item.mixName = name;
        item.mixTime = mixTime;
        item.mixId = mixId;
        item.mixInfoList.forEach((items, indexs) => {
          if (items.id != "") {
            items.rawList = [];
            items.rawFormId = "";

            getRaw({ lineId: item.lineId, rawId: items.id, page: 1, pageSize: 1000 }).then(res => {
              if (res.code === 1001) {
                let rawFormList = [];
                rawFormList = res.data?.map(itemRaw => ({
                  warehouseId: itemRaw.warehouseId,
                  warehouseName: itemRaw.warehouseName,
                  warehouseCode: itemRaw.originPlace,
                }));
                if (rawFormList?.length > 0) {
                  that.$set(that.lineList[index].mixInfoList[indexs], "rawList", rawFormList);
                  that.$set(that.lineList[index].mixInfoList[indexs], "rawFormId", "");
                  if (rawFormList?.length == 1) {
                    that.$set(that.lineList[index].mixInfoList[indexs], "rawFormId", rawFormList[0].warehouseId);
                    that.$set(that.lineList[index].mixInfoList[indexs], "rawForm", rawFormList[0].warehouseName);
                    that.$set(that.lineList[index].mixInfoList[indexs], "rawFormCode", rawFormList[0].warehouseCode);
                    that.$set(that.lineList[index].mixInfoList[indexs], "rawFormCodeOut", items.rawFormCodeOut ? items.rawFormCodeOut : rawFormList[0].warehouseCode);
                  }
                }
              }
            });
          }
          that.$set(items, "theoreValueTrue", items.theoreValue);
          that.$set(items, "theoreValueTrueOut", (items.theoreValueTrueOut || items.theoreValueTrueOut == 0) ? items.theoreValueTrueOut : items.theoreValue);
        });
      });
      // 使用 $nextTick 来确保更新在 DOM 渲染后执行
      this.$nextTick(() => {
        // 触发页面更新
        console.log(that.lineList, "lineListOld");
        that.lineList = JSON.parse(JSON.stringify(that.lineList));
        console.log(that.lineList, "lineListNew");
      });
      // that.$forceUpdate();
      //  that.lineList = array;
      //  console.log(that.lineList, "lineList");
      //  console.log(array, ":arr");
    },

    resetRawFromDate() {
      this.isSave = true;
      this.lineList[this.currentIndex].mixInfoList = [{ id: "", name: "容重", theoreValue: "", theoreValueTrue: "", deviation: "", rawFormId: "", rawList: [] }];
      this.$emit("update:mixRatioDialog", false);
      this.$parent.initData();
    },
    /*保存/修改弹窗*/
    saveRawFromDate: _debounce(function (type) {
      let isOkType = false;
      let isNullType = false;
      let isRawType = false;
      let lineName = "";
      let isFalseType = false;
      let hasDuplicateRawFormId = false;
      let paramsArr = JSON.parse(JSON.stringify(this.lineList));
      // let filteredData = paramsArr.filter(item => item.mixInfoList.length !== 1);
      if (paramsArr.length > 0) {
        paramsArr.forEach(item => {
          item.planId = this.rowData.id;
          item.stationId = this.rowData.stationId;
          item.mixTime = item.mixTime * 1;
          item.stationName = this.rowData.stationName;
          item.mixInfo = JSON.stringify(item.mixInfoList);
        });
      }
      this.lineList = JSON.parse(JSON.stringify(paramsArr));
      let filteredData = paramsArr.filter(item => item.enable == 1);
      const checkDataValidity = data => {
        if (data.deviation === "" || data.deviation === null) {
          return true; // deviation为空时直接返回true，数据有效
        }
        console.log(data.theoreValueTrue, data.theoreValue, Number(data.deviation));
        return Math.abs(data.theoreValueTrue - data.theoreValue) <= Number(data.deviation);
      };

      if (filteredData.length > 0) {
        filteredData.forEach(item => {
          // item.planId = this.rowData.id;
          // item.stationId = this.rowData.stationId;
          // item.mixTime = item.mixTime * 1;
          // item.stationName = this.rowData.stationName;
          // item.mixInfo = JSON.stringify(item.mixInfoList);
          console.log(item.mixTime);
          console.log(item.mixInfoList);
          if (item.mixTime == null || item.mixTime === "" || item.mixTime == 0) {
            isOkType = true;
            return;
          }
          // if (!item.mixInfoList.every(items => checkDataValidity(items))) {
          //   isFalseType = true;
          //   return;
          // }
          if (
            !item.mixInfoList.every(items => {
              // 如果deviation为空，则直接返回true，表示该数据有效
              if (items.deviation === "") {
                return true;
              }
              return checkDataValidity(items);
            })
          ) {
            isFalseType = true;
            return;
          }
          hasDuplicateRawFormId = item.mixInfoList.some((items, index) => {
            if (items.rawFormId) {
              return item.mixInfoList.findIndex((element, idx) => element.rawFormId === items.rawFormId && idx !== index) !== -1;
            }
          });
          if (item.mixInfoList.some(items => items.theoreValueTrue === "")) {
            isOkType = true;
            return;
          }
          // if (item.mixInfoList.some(items => (items.name !== "容重" && items.rawList.length > 0 && items.rawFormId === "") || (items.name !== "容重" && items.rawList.length === 0))) {
          //   isRawType = true;
          //   return;
          // }
          if (item.mixInfoList.some(items => items.name !== "容重" && items.name !== "胶凝材料" && ((items.rawList.length > 0 && items.rawFormId === "") || items.rawList.length === 0))) {
            lineName = item.lineName;
            isRawType = true;
            return;
          }
        });
      } else {
        isNullType = true;
      }
      console.log(isFalseType);
      if (isNullType) {
        this.$message({
          type: "warning",
          message: "请填写数据！！",
        });
        return;
      } else if (hasDuplicateRawFormId) {
        this.$message({
          type: "warning",
          message: "存在相同原料库",
        });
        return;
      } else if (isRawType) {
        this.$message({
          type: "warning",
          message: "请先去维护" + lineName + "原料库！",
        });
        return;
      } else if (isOkType) {
        this.$message({
          type: "warning",
          message: "请检查是否所有项都已填写！！！",
        });
        return;
      } else if (isFalseType) {
        this.$message({
          type: "warning",
          message: "实际用量大于偏差，请重新填写！",
        });
        return;
      } else {
        // this.saveLoad = true;
        if (type == 1) {
          let dataArr = JSON.parse(JSON.stringify(this.lineList));
          console.log(dataArr)
          dataArr.forEach(item => {
            let index = item.mixInfoList.findIndex(item2 => item2.name == "容重");
            item.theoreValueTrue = item.mixInfoList[index].theoreValueTrue;
            item.theoreValue = item.mixInfoList[index].theoreValue;
            item.deviation = item.mixInfoList[index].deviation;
            if (index !== -1) {
              item.mixInfoList.splice(index, 1);
            }

            let index2 = item.mixInfoList.findIndex(item3 => item3.name == "胶凝材料");
            if (index2 !== -1) {
              item.mixInfoList.splice(index2, 1);
            }
            item.mixInfo = JSON.stringify(item.mixInfoList);
          });
          this.saveMixRatioDataArr = dataArr
          this.saveMixRatioDialog = true
          console.log(this.saveMixRatioDataArr)
        }
        if (type == 2) {
          let dataArr2 = JSON.parse(JSON.stringify(this.lineList));
          dataArr2.forEach(item => {
            let index = item.mixInfoList.findIndex(item2 => item2.name == "容重");

            item.theoreValueTrue = item.mixInfoList[index].theoreValueTrue;
            item.theoreValue = item.mixInfoList[index].theoreValue;
            item.deviation = item.mixInfoList[index].deviation;
            if (index !== -1) {
              item.mixInfoList.splice(index, 1);
            }
            let index2 = item.mixInfoList.findIndex(item3 => item3.name == "胶凝材料");
            if (index2 !== -1) {
              item.mixInfoList.splice(index2, 1);
            }
            item.mixInfo = JSON.stringify(item.mixInfoList);
          });
          saveMixRatio({
            whetherSend: 1,
            proportionList: dataArr2,
          }).then(res => {
            if (res.code === 1001) {
              this.$message.success("保存成功");
              this.$emit("selectRatioDetail");
              this.resetRawFromDate();
            }
          });
        }
      }
      console.log(filteredData);
    }, 1000),
    saveMixRatioDebounce: _debounce(function (type) {
      let dataArr = this.saveMixRatioDataArr
      console.log(this.saveMixRatioDataArr)
      if (type) {
        // 处理确认操作
        saveMixRatio({
          whetherSend: 1,
          proportionList: dataArr,
        })
          .then(res => {
            if (res.code === 1001) {
              this.$message.success("保存成功");
              this.saveMixRatioDialog = false
              this.$emit("selectRatioDetail");
              this.resetRawFromDate();
            }
            this.saveLoad = false;
          })
          .catch(() => {
            this.saveLoad = true;
            this.saveMixRatioDialog = false
          });
      } else {
        // 处理取消操作
        saveMixRatio({
          whetherSend: 0,
          proportionList: dataArr,
        })
          .then(res => {
            if (res.code === 1001) {
              this.$message.success("保存成功");
              this.$emit("selectRatioDetail");
              this.saveMixRatioDialog = false
              this.resetRawFromDate();
            }
            this.saveLoad = false;
          })
          .catch(() => {
            this.saveLoad = true;
            this.saveMixRatioDialog = false
          });
      }
    }, 1000),
    transferMixer() {
      console.log();
    },
  },
};
</script>

<style lang="scss" scoped>
.title_box {
  display: block;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 22px;
  color: #000000;
  margin-bottom: 10px;
}

.el-form-item__label {
  color: #000000;
  font-size: 14px;
}

.table_link {
  margin-left: 10px;
  color: $bg_color;
}

.table_link:hover {
  opacity: 0.8;
}

.tabtop {
  display: flex;
  margin: 20px 20px 0 20px;
  border: $bg_color 1px solid;
  border-radius: 4px;

  >div {
    height: 40px;
    width: 190px;
    font-size: 16px;
    font-weight: 400;
    cursor: pointer;
    display: flex;
    align-items: center;

    .text {
      width: 188px;
      @include discen;
      line-height: 40px;
      color: $bg_color;
    }

    .textEnable {
      width: 188px;
      @include discen;
      line-height: 40px;
      color: red;
    }

    .active {
      width: 189px;
      @include discen;
      line-height: 40px;
      color: #ffffff;
      background: $bg_color;
    }

    .activeEnable {
      width: 189px;
      @include discen;
      line-height: 40px;
      color: #ffffff;
      background: red;
    }

    .hr {
      height: 20px;
      width: 2px;
      background: $bg_color;
    }
  }
}
</style >
<style scoped>
::v-deep .el-table .cell {
  text-align: center;
}

::v-deep .sortable-chosen>td {
  /* 拖动的样式 */
  background-color: #eff2f6 !important;
  color: #409eff;
}

::v-deep .el-table--enable-row-hover .el-table__body tr:hover>td {
  /* 修复拖拽的时候hover的不消失的问题 */
  background-color: #fff;
}
</style>